var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 31,
    viewBox: "0 0 62 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5C0 6.93959 6.93765 0 15.4981 0C20.6964 0 26.3491 0 31 0C35.6509 0 41.3036 0 46.5019 0C55.0624 0 62 6.93959 62 15.5C62 24.0604 55.0604 31 46.5 31H15.5C6.93959 31 0 24.0604 0 15.5Z",
    fill: "url(#paint0_linear_14149_87217)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9141 21.5518C42.1696 21.729 41.3479 21.8406 40.5 21.8406C36.1586 21.8406 33 19.1344 33 14.8966V12.944C33 8.70624 36.2371 6 40.5 6C44.7903 6 48 8.70624 48 12.944V14.8966C48 17.581 46.7151 19.6659 44.6858 20.82L46.8944 24.1039C46.8944 24.1039 47.0227 24.3697 46.2009 24.8139C45.6619 25.1027 45.1738 24.9692 45.1738 24.9692L42.9141 21.5518ZM35.3369 15.1624C35.3369 18.291 37.4945 20.0652 40.5 20.0652C43.5316 20.0652 45.6892 18.291 45.6892 15.1624V12.6782C45.6892 9.54967 43.4544 7.7536 40.5 7.7536C37.5717 7.7536 35.3369 9.55088 35.3369 12.6782V15.1624Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9874 7.44213C29.9485 7.24065 29.6842 7 28.6406 7C27.5639 7 27.2858 7.24401 27.2138 7.394L22.0544 18.839L16.8709 7.38952C16.8011 7.24401 16.5196 7.00111 15.4223 7.00111C14.4783 7.00111 14 7.16342 14 7.48243V7.53056L20.6801 21.5332C20.719 21.6116 20.9708 22 22.0555 22C23.1174 22 23.3679 21.6116 23.4091 21.5276L29.9703 7.5742L30 7.51152L29.9874 7.44213Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14149_87217",
    x1: 31,
    y1: -0.00000156393,
    x2: 58.9305,
    y2: 37.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA3E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE2818"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.ee11e9d8371b7d1b5fb872bd76cb7773.svg";
export { ForwardRef as ReactComponent };